// extracted by mini-css-extract-plugin
export var formContainer = "_im-0";
export var message = "_im-1";